import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { OneOrgContextProvider } from "@/auth/OneOrgContext";
import { SessionProvider } from "@/auth/SessionProvider";
import { ThemeProvider } from "@/components/ThemeProvider";
import { App } from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <SessionProvider>
          <OneOrgContextProvider>
            <App />
          </OneOrgContextProvider>
        </SessionProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
